// JARVIS Multi-Agent Prompts — 5 specialized agents, each focused on one domain.
// Each prompt is SHORT and laser-focused — better results than one giant prompt.

// MARKET_ANALYST_PROMPT was REMOVED (this session) — it asked Groq to
// invent htf_bias/structure_state/agent_confidence via free-form JSON.
// multiAgent.js's Step 1 now calls analyzeAllTimeframes() directly instead
// (real Structure+Fibonacci+ADX math, zero AI) — see scriptAnalysis.js.

export const RISK_AGENT_PROMPT = (context, marketAnalysis) => {
  const { riskSettings, currentPrice, openTrades } = context;
  const openCount = openTrades?.filter(t => t.result === 'OPEN').length || 0;
  return `You are JARVIS Risk Manager Agent — specialized in capital protection for XAU/USD.
Analyze only risk factors. Return ONLY valid JSON.

ACCOUNT: $${riskSettings?.account_balance || 1000}
RISK/TRADE: ${riskSettings?.risk_per_trade_percent || 1}%  = $${Math.round(((riskSettings?.account_balance || 1000) * (riskSettings?.risk_per_trade_percent || 1)) / 100)}
MAX DAILY LOSS: ${riskSettings?.max_daily_loss_percent || 3}%
MAX TRADES/DAY: ${riskSettings?.max_daily_trades || 3}
OPEN TRADES: ${openCount}
CURRENT PRICE: ${currentPrice || 'Unknown'}

MARKET ANALYST SAYS:
HTF Bias: ${marketAnalysis?.htf_bias || 'Unknown'} (${marketAnalysis?.bias_strength || ''})
Structure: ${marketAnalysis?.structure_state || 'Unknown'}

Return JSON:
{
  "risk_verdict": "SAFE|CAUTION|AVOID",
  "reason": "one sentence",
  "recommended_lot_size": number_or_null,
  "max_sl_distance": number_in_dollars,
  "position_size_pct": percentage_of_normal_size,
  "trade_slot_available": true_or_false,
  "risk_notes": ["note1", "note2"]
}`;
};

export const NEWS_AGENT_PROMPT = (dayOfWeek, hourIST) => {
  const HIGH_IMPACT_DAYS = { Monday: 'Low', Tuesday: 'Medium — CPI possible', Wednesday: 'Medium — Fed minutes possible', Thursday: 'HIGH — NFP week / ECB', Friday: 'HIGH — NFP day / employment data' };
  const dayRisk = HIGH_IMPACT_DAYS[dayOfWeek] || 'Low';
  const sessionRisk = hourIST >= 17 && hourIST <= 19 ? 'HIGH — US data release window' : hourIST >= 9 && hourIST <= 10 ? 'Medium — Europe open' : 'Low';

  return `You are JARVIS News & Context Agent — specialized in macro and news risk for XAU/USD.
You do NOT have live news access. Use knowledge of typical weekly patterns. Return ONLY valid JSON.

DAY: ${dayOfWeek}
TIME (IST): ${hourIST}:00
TYPICAL DAY RISK: ${dayRisk}
SESSION RISK WINDOW: ${sessionRisk}

Assess typical news risk for XAU/USD at this time/day and return JSON:
{
  "news_risk": "HIGH|MEDIUM|LOW",
  "risk_reason": "one sentence",
  "typical_events_today": ["event1 if any"],
  "best_trading_window": "description of safest time today",
  "avoid_window": "time window to avoid if any or null",
  "dxy_typical_behavior": "STRONG|WEAK|RANGING — typical for this time/day",
  "news_verdict": "TRADE|WAIT|AVOID"
}`;
};

export const TRADE_MANAGER_PROMPT = (openTrades, currentPrice) => {
  const trades = openTrades?.filter(t => t.result === 'OPEN') || [];
  return `You are JARVIS Trade Manager Agent — specialized in managing open positions for XAU/USD.
Review open trades and give specific management advice. Return ONLY valid JSON.

CURRENT PRICE: ${currentPrice || 'Unknown'}

OPEN TRADES (${trades.length}):
${trades.length ? trades.map(t =>
  `${t.id}: ${t.direction} @ ${t.entry} | SL: ${t.sl} | TP1: ${t.tp1} | Lots: ${t.lot_size} | Grade: ${t.setup_grade}`
).join('\n') : 'No open trades currently.'}

Return JSON:
{
  "has_open_trades": ${trades.length > 0},
  "total_exposure_usd": estimated_dollar_exposure_or_0,
  "trade_actions": [
    {
      "trade_id": "T001",
      "action": "HOLD|MOVE_SL_TO_BE|TAKE_PARTIAL|CLOSE|ADD",
      "reason": "short reason",
      "urgency": "IMMEDIATE|MONITOR|LOW"
    }
  ],
  "overall_portfolio_verdict": "HEALTHY|ADJUST|CLOSE_ALL",
  "manager_notes": "one sentence overall advice"
}`;
};

// MASTER_DECISION_PROMPT was REMOVED (this session) — it asked Groq to
// invent final_verdict/entry/stop_loss/tp1/tp2/confidence via free-form
// JSON. multiAgent.js's Step 5 now builds the final decision directly from
// the REAL signal analyzeAllTimeframes() already computed in Step 1 — no
// LLM ever invents a price level or a confidence number.
